import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties } from 'react';
import { Genre } from '../../types/types';
interface PropTypes {
  style?: CSSProperties;
  data: Genre;
  onClick?: () => void;
  className?: string;
}
function GenreItem(t0) {
  const $ = _c(6);
  const {
    data,
    onClick,
    className
  } = t0;
  const t1 = `flex justify-center items-center rounded-md px-4 w-[100px] md:w-[130px] h-[100px] md:h-[130px] bg-black text-white hover:bg-gray-200 ${className}`;
  let t2;
  if ($[0] !== data.name) {
    t2 = <span className="text-center text-xs md:text-sm font-bold text-white">{data.name}</span>;
    $[0] = data.name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick || $[3] !== t1 || $[4] !== t2) {
    t3 = <div className={t1} onClick={onClick}>{t2}</div>;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default GenreItem;